import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_default.png");
;
import(/* webpackMode: "eager" */ "/app/public/images/og_image_homepage.png");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/app/src/components/Accordion/Accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppRatingSection"] */ "/app/src/components/AppRatingSection/AppRatingSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/BottomDownloadSection/assets/mobilePhonePreview.png");
;
import(/* webpackMode: "eager" */ "/app/src/components/BottomDownloadSection/assets/waveBlueBottom.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/BottomDownloadSection/BottomDownloadSection.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/BragBar/assets/bragIconBests.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/BragBar/assets/bragIconFish.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/BragBar/assets/bragIconGear.svg");
;
import(/* webpackMode: "eager" */ "/app/src/components/Clickables/Buttons/AppStoreButtons/AppStoreButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalLink"] */ "/app/src/components/Clickables/ExternalLink/ExternalLink.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/QRCode/QRCode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSectionList"] */ "/app/src/components/ReviewSection/ReviewSectionList.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/depthLeft.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/depthRight.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/catchesBannerDesktop.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/catchesBannerMobile.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/catchesBannerTablet.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/catchesPhone.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/regsBannerDesktop.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/regsBannerMobile.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/regsBannerTablet.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/regsPhone.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/reportBGdesktop.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/reportBGmobile.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/reportBGtablet.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/reportsPhone.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/spotBannerDesktop.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/spotBannerMobile.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/spotBannerTablet.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/featureSections/spotPhone.png");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/header/headerWaveMobile.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/header/headerWaveTablet.svg");
;
import(/* webpackMode: "eager" */ "/app/src/views/Homepage/assets/header/phonePreview.png");
;
import(/* webpackMode: "eager", webpackExports: ["HomePageFeatureSectionLink"] */ "/app/src/views/Homepage/components/HomePageFeatureSection/components/HomePageFeatureSectionLink.tsx");
